/* eslint-disable prettier/prettier */
/* eslint-disable react/no-array-index-key */
/* eslint-disable default-param-last */
/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
import React, { useContext, useState } from "react";
import { IconButton, Box, TableRow, TableCell } from "@mui/material";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { format } from "date-fns";
import { Navigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
import CustomTable from "../../../../components/common/new/Table/Table";
import Typography from "../../../../components/common/new/Typography/Typography";
import Modal from "../../../../components/common/Modal/Modal";
import Button from "../../../../components/common/Button";
import styles, { tabelCellWidth } from "./OrganizationStructure.styles";
import Alert from "../../../../components/common/new/Alert/Alert";
import SuccessfullyBookedModal from "../../../../components/SuccessfullyBookedModal/SuccessfullyBookedModal";
import { ToastAlertContext } from "../../../../config/providers/ToastAlert";
import Appointment from "../../../../services/api/appointment";
import { AlertStatus } from "../../../../contants";
import Eye from "../../../../assets/svg/Eye";
import ReplacingModal from "./appointmentHistory";

import DatePicker from "./DatePicker/DatePicker";

const EXISTING_APPOINTMENT_COL = [
  {
    displayName: "S No",
    key: "number",
  },
  {
    displayName: "MEMBER NAME",
    key: "memberName",
  },
  {
    displayName: "Member Address",
    key: "address",
  },
  {
    displayName: "Contact Info",
    key: "contactInfo",
  },
  {
    displayName: "Organisation Structure",
    key: "organisationStructure",
  },
  {
    displayName: "History",
    key: "history",
  },
];

const NEW_APPOINTMENT_COL = [
  {
    displayName: "MEMBER NAME",
    key: "memberName",
  },
  {
    displayName: "Member Address",
    key: "address",
  },
  {
    displayName: "Contact Info",
    key: "contactInfo",
  },
  {
    displayName: "Organisation Structure",
    key: "organisationStructure",
  },
  {
    displayName: "Appointment Date",
    key: "appointmentDate",
  },
  {
    displayName: "History",
    key: "history",
  },
];

const CEASE_APPOINTMENT_COL = [
  {
    displayName: "Select",
    key: "memberName",
  },
  {
    displayName: "Position",
    key: "position",
  },
  {
    displayName: "Position Type",
    key: "positionType",
  },
];

function SelectMemberModal({
  open,
  onClose,
  // selectedMembers,
  selectedMemberData,
  appointedMembers,
  selectedMemberId,
  type,
}) {
  const [openAlert, setOpenAlert] = useState(false);
  const [successModal, setSuccesModal] = useState(false);
  const [appointedEmail, setAppointedEmail] = useState(null);
  const [appointedPosition, setAppointedPosition] = useState(null);
  const toast = useContext(ToastAlertContext);
  const [openModal, setOpenModal] = useState(false);
  const [selectedMember, setSelectedMember] = useState("");
  const [selectedAppointmentDate, setSelectedAppointmentDate] = useState(
    new Date()
  );
  const [selectedCeasePositions, setSelectedCeasePositions] = useState([]);

  const toggleCeasePositionSelection = (positionId) => {
    if (selectedCeasePositions.includes(positionId)) {
      setSelectedCeasePositions((prev) =>
        prev.filter((id) => id !== positionId)
      );
    } else {
      setSelectedCeasePositions((prev) => [...prev, positionId]);
    }
  };

  const onBack = () => Navigate(-1);

  const acceptAppointmentHandler = (selectedMemberId) => {
    console.log("selectedMemberId", selectedMemberId);
    setOpenAlert(true);
  };

  const toggleAlert = () => {
    setOpenAlert(false);
  };

  const toggleSuccessModal = () => setSuccesModal((prev) => !prev);

  const onSelectMember = (selectedMember) => {
    setOpenModal(true);
    setSelectedMember(selectedMember);
  };

  const closeModal = () => {
    setOpenModal(false);
  };

  const markAppointmentHandler = async () => {
    if (selectedMemberId) {
      try {
        const { positionId, overridePosition, selectedMembers } =
          appointedMembers[0];
        const body = {
          positionId,
          existingMemberIds: [...selectedMembers],
          overridePosition,
          appointedAt: format(selectedAppointmentDate, "yyyy-MM-dd"),
          type,
          ceasePositionIds: selectedCeasePositions,
        };
        const { data } = await Appointment.directAppointment(
          selectedMemberId,
          body
        );
        toast.show("Successfully Done", AlertStatus.SUCCESS);
        setAppointedEmail(selectedMemberData[0].emailId);
        setAppointedPosition(data.positionName);
        toggleAlert();
        toggleSuccessModal();
        setTimeout(() => {
          onClose();
          toggleAlert();
          toggleSuccessModal();
          onBack();
        }, 2000);
      } catch (err) {
        toast.show(err.message, AlertStatus.ERROR);
        Sentry.captureException(err);
      }
    }
  };

  const onDateSelect = (appointedAt) => {
    setSelectedAppointmentDate(new Date(appointedAt));
  };

  const getRowExistingMembers = (data) => {
    if (!Array.isArray(data)) {
      return null;
    }
    const rows = data.map((item, index) => (
      <TableRow key={index}>
        <TableCell style={{ ...tabelCellWidth.tiny }}>{index + 1}</TableCell>
        <TableCell>{item?.fullName || "NA"}</TableCell>
        <TableCell style={{ ...tabelCellWidth.large }}>
          <Typography
            variant="small"
            style={{
              ...styles.largeText,
              lineHeight: "17px",
              color: "rgba(0, 0, 0, 0.87)",
            }}
          >
            {item?.addressLine1 || "NA"}
          </Typography>
        </TableCell>
        <TableCell style={{ ...styles.greyTableCell, ...tabelCellWidth.large }}>
          {item?.mobileNumber || "NA"}
          <br />
          <Typography
            variant="small"
            style={{
              color: "rgba(0, 0, 0, 0.87)",
            }}
          >
            {item?.emailId || "NA"}
          </Typography>
        </TableCell>
        <TableCell>
          {[
            item?.areaName,
            item?.clusterName,
            item?.zoneName,
            item?.regionName,
            item?.chapterName,
            item?.districtName,
            item?.blockName,
          ]
            .filter(Boolean)
            .join("/ ") || "NA"}
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          {" "}
          <div style={styles.actionButtons}>
            <Eye
              style={{ ...styles.actionIcon, marginTop: "4px" }}
              onClick={() => onSelectMember(item?.memberId)}
            />
          </div>
        </TableCell>
      </TableRow>
    ));

    return rows;
  };

  const getRowMembers = (data) => {
    if (!Array.isArray(data)) {
      return null;
    }
    const rows = data.map((item, index) => (
      <TableRow key={index}>
        <TableCell>
          {item?.fullName || item?.memberDetails?.fullName || "NA"}
        </TableCell>
        <TableCell style={{ ...tabelCellWidth.large }}>
          <Typography
            variant="small"
            style={{
              ...styles.largeText,
              lineHeight: "17px",
              color: "rgba(0, 0, 0, 0.87)",
            }}
          >
            {item?.addressLine1 || item?.memberDetails?.addressLine1 || "NA"}
          </Typography>
        </TableCell>
        <TableCell style={{ ...styles.greyTableCell, ...tabelCellWidth.large }}>
          {item?.mobileNumber || item?.memberDetails?.mobileNumber || "NA"}
          <br />
          <Typography
            variant="small"
            style={{
              color: "rgba(0, 0, 0, 0.87)",
            }}
          >
            {item?.emailId || item?.memberDetails?.emailId || "NA"}
          </Typography>
        </TableCell>
        <TableCell>
          {[
            item?.areaName || item?.memberDetails?.areaName,
            item?.clusterName || item?.memberDetails?.clusterName,
            item?.zoneName || item?.memberDetails?.zoneName,
            item?.regionName || item?.memberDetails?.regionName,
            item?.chapterName || item?.memberDetails?.chapterName,
            item?.districtName || item?.memberDetails?.districtName,
            item?.blockName || item?.memberDetails?.blockName,
          ]
            .filter(Boolean)
            .join("/ ") || "NA"}
        </TableCell>
        <TableCell
          style={{ ...styles.blueTableCell, ...tabelCellWidth.normal }}
        >
          <DatePicker
            defaultValue={selectedAppointmentDate}
            disableFuture
            // minDate={new Date(new Date().setMonth(new Date().getMonth() - 1))}
            onDateSelect={onDateSelect}
          >
            <Typography
              weight={500}
              variant="small"
              style={{
                border: "1px solid #897c6f ",
                padding: "5px 5px",
                display: "flex",
                alignItems: "center",
              }}
            >
              {selectedAppointmentDate
                ? format(selectedAppointmentDate, "dd-MM-yyyy")
                : "NA"}
              <CalendarMonthOutlinedIcon style={{ paddingLeft: "5px" }} />
            </Typography>
          </DatePicker>
        </TableCell>
        <TableCell style={tabelCellWidth.medium}>
          {" "}
          <div style={styles.actionButtons}>
            <Eye
              style={{ ...styles.actionIcon, marginTop: "4px" }}
              onClick={() =>
                onSelectMember(item?.memberId || item?.memberDetails?.memberId)
              }
            />
          </div>
        </TableCell>
      </TableRow>
    ));

    return rows;
  };

  const getRowCeaseMembers = (data) => {
    if (!Array.isArray(data)) {
      return null;
    }

    const rows = data.map((item) => {
      const positions = item.positions || [];
      if (positions.length === 0) {
        return (
          <TableRow key={item.id}>
            <TableCell colSpan={3} style={{ textAlign: "center" }}>
              No Results
            </TableCell>
          </TableRow>
        );
      }
      const positionItems = positions.map((positionItem, positionIndex) => (
        <TableRow key={positionIndex}>
          <TableCell>
            <input
              type="checkbox"
              checked={selectedCeasePositions.includes(positionItem.id)}
              onChange={() => toggleCeasePositionSelection(positionItem.id)}
            />
          </TableCell>
          <TableCell>{positionItem.name || "NA"}</TableCell>
          <TableCell>
            {positionItem.positionType?.split("_")[0] || "NA"}
          </TableCell>
        </TableRow>
      ));

      return positionItems;
    });

    return rows;
  };

  return (
    <Modal open={open} customStyle={{ top: "53%", left: "50%" }}>
      <Box style={styles.container}>
        <Box
          style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "1rem",
          }}
        >
          <Typography component="p" color="#8C8C8C" weight={500} my={4} />
          <IconButton>
            <CloseIcon onClick={onClose} />
          </IconButton>
        </Box>
        <Box>
          <div
            style={{
              maxHeight: "65vh",
              overflow: "auto",
            }}
          >
            <Box style={{ display: "flex", gap: "1rem" }} />
            <Box style={{ display: "flex", justifyContent: "space-between" }}>
              <Box>
                <Typography component="p" color="#8C8C8C" weight={500} my={4}>
                  Appointment For{" "}
                  <span style={{ fontWeight: "bold", color: "#8C8C8C" }}>
                    {appointedMembers[0].valuesArray} -{" "}
                    {appointedMembers[0].positionName}
                  </span>
                  {appointedMembers[0].divisionName && (
                    <span style={{ fontWeight: "bold", color: "#8C8C8C" }}>
                      {" "}
                      of {appointedMembers[0].divisionName}
                    </span>
                  )}
                </Typography>
              </Box>
            </Box>
            {appointedMembers[0].selectedMembersDetails.length > 0 && (
              <>
                <Box
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Box justifyContent="center">
                    <Typography
                      component="p"
                      color="#8C8C8C"
                      weight={500}
                      my={4}
                    >
                      Existing Appointment(s) for{" "}
                      {appointedMembers[0].positionName}
                    </Typography>
                  </Box>
                </Box>
                <CustomTable
                  columnCellStyle={{ textAlign: "left" }}
                  scrollable
                  columns={EXISTING_APPOINTMENT_COL}
                  rows={getRowExistingMembers(
                    appointedMembers[0].selectedMembersDetails
                  )}
                  tableBodyTheme="#F6F6F6"
                  tableHeadCellStyle={{
                    ...styles.tableHeadCells,
                  }}
                />
              </>
            )}
            <Box style={{ display: "flex", justifyContent: "space-between" }}>
              <Box justifyContent="center">
                <Typography component="p" color="#8C8C8C" weight={500} my={4}>
                  New Appointment(s) for {appointedMembers[0].positionName}
                </Typography>
              </Box>
            </Box>
            <CustomTable
              columnCellStyle={{ textAlign: "left" }}
              scrollable
              columns={NEW_APPOINTMENT_COL}
              rows={getRowMembers(selectedMemberData)}
              tableBodyTheme="#F6F6F6"
              tableHeadCellStyle={{
                ...styles.tableHeadCells,
              }}
            />
            {type === "adhoc" && (
              // selectedMemberData.positions &&
              // selectedMemberData.positions.length > 0 &&
              <>
                <Box
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Box justifyContent="center">
                    <Typography
                      component="p"
                      color="#8C8C8C"
                      weight={500}
                      my={4}
                    >
                      Ceasing New Member Appointment Position
                    </Typography>
                  </Box>
                </Box>
                <CustomTable
                  columnCellStyle={{ textAlign: "left" }}
                  scrollable
                  columns={CEASE_APPOINTMENT_COL}
                  rows={getRowCeaseMembers(selectedMemberData)}
                  tableBodyTheme="#F6F6F6"
                  tableHeadCellStyle={{
                    ...styles.tableHeadCells,
                  }}
                />
              </>
            )}
          </div>
          <Box
            style={{
              marginTop: "20px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button
              type="submit"
              variant="contained"
              label="Submit"
              onClick={() => acceptAppointmentHandler(selectedMemberId)}
            />
          </Box>
        </Box>
        <Alert
          open={openAlert}
          onClose={toggleAlert}
          onSubmit={markAppointmentHandler}
        />
        <SuccessfullyBookedModal
          open={successModal}
          onClose={toggleSuccessModal}
          email={appointedEmail}
          position={appointedPosition}
        />
        <ReplacingModal
          open={openModal}
          onClose={closeModal}
          selectedMember={selectedMember}
        />
      </Box>
    </Modal>
  );
}

export default SelectMemberModal;
